export const ids = [
	//
	'readyForDesign',
	'designInProgress',
	'approvedByDesigner',

	//
	'readyForReview',
	'reviewInProgress',
	'approvedByReviewer',

	//
	'readyForQA',
	'qaInProgress',
	'approvedByQA',

	//
	'readyForRework',
	'reworkInProgress',

	//
	'finalise',
	'complete',

	// Alternative complete statuses,
	'approvedByDesigner',
	'approvedByReviewer',
	'approvedByQA',

	//
	'completedWon',
	'completedLost',
	'completedOnHold',

	//
	'ready',
	'inProgress',

	//
	'unAllocated',
	'unAssigned',

	//
	'notRequired',
	'pending',

	// Exception statuses,
	'cancelled',
	'failed',
	'aborted',
	'onHold',
	'pendingFeedback',

	// client facing ones
	'pending',
	'assigned',
	'review',

	// pricing / estimate management
	'sentToCustomer',
	'followUpScheduled',

	// accountingReviewPreDesign
	'creditApproved',
	'creditIssue',
	'followUpRequired',
	'followUpCompleted',

	// production specific statuses
	'paperworkCompleted',
	'lumberPulling',
	'cutting',
	'fabrication',
] as const;
